import { useCallback } from 'react';

import { EAvailableLanguages } from '@/configuration/lang/types';

type GridProps = {
  yScale: d3.ScaleLinear<number, number, never>;
  boundsWidth: number;
  locale: EAvailableLanguages;
};

export const Grid = ({ yScale, boundsWidth, locale }: GridProps) => {
  const formattedValue = useCallback(
    (value: number) => {
      const formatter = new Intl.NumberFormat(locale);
      const formattedValue = typeof value === 'number' ? formatter.format(value) : `${value}`;
      return formattedValue;
    },
    [locale],
  );

  return (
    <>
      {yScale.ticks(5).map((value, i) => (
        <g key={i}>
          <line x1={0} x2={boundsWidth} y1={yScale(value)} y2={yScale(value)} stroke="#808080" opacity={0.2} />
          <text
            x={-10}
            y={yScale(value)}
            textAnchor="middle"
            alignmentBaseline="central"
            fontSize={9}
            stroke="#808080"
            opacity={0.8}
          >
            {formattedValue(value)}
          </text>
        </g>
      ))}
    </>
  );
};
